var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("Your files have been submitted")])])])])])
}]

export { render, staticRenderFns }